export const siteConfig = {
  siteUrl: 'https://jamaklab.com',
  siteName: 'Jamak',
  siteTitle: 'JAMAK — AI implementation agency',
  siteDescription: 'AI implementation agency for businesses ready to put AI to work. AI agents, workflow automation, websites and Shopify stores. Building since 2011.',
  siteKeywords: 'Fractional growth partner, AI implementation, AI agents, SEO, GEO, Generative Engine Optimization, CRO, Conversion Rate Optimization, Shopify Development, AI Marketing, Digital Agency, Mexico',
  siteImage: 'https://jamaklab.com/images/og/og-image.png?v=r02',
  twitterImage: 'https://jamaklab.com/images/og/twitter-card.png?v=r02',
  linkedinImage: 'https://jamaklab.com/images/og/linkedin-card.png?v=r02',
  facebookImage: 'https://jamaklab.com/images/og/facebook-card.png?v=r02',
  squareImage: 'https://jamaklab.com/images/og/og-square.png?v=r02',
  siteIcon: 'https://jamaklab.com/images/og/favicon-32.png?v=r02',
  appleTouchIcon: 'https://jamaklab.com/images/og/apple-touch-icon.png?v=r02',
  author: 'Jamak',
  locale: 'en_US',
  alternateLocales: ['es_MX'],
  organization: {
    name: 'Jamak',
    url: 'https://jamaklab.com',
    logo: 'https://jamaklab.com/images/logos/logo-jamak.png'
  },
  contact: {
    email: 'hello@jamaklab.com',
    address: {
      streetAddress: 'Polanco',
      addressLocality: 'Mexico City',
      addressRegion: 'CDMX',
      postalCode: '11560',
      addressCountry: 'MX'
    }
  }
};

export const pageMetadata = {
  home: {
    title: 'JAMAK — AI implementation agency',
    description: 'AI implementation agency for businesses ready to put AI to work. AI agents, workflow automation, websites and Shopify stores. Building since 2011.',
    keywords: 'fractional growth partner, AI implementation, AI agents, SEO, GEO, CRO, Shopify, Shopify Select Partner',
    image: 'https://jamaklab.com/images/og/og-image.png?v=r02'
  },
  blog: {
    title: 'Digital Marketing Blog | SEO, GEO & CRO Insights | Jamak',
    description: 'Expert insights on SEO, GEO, CRO, and digital marketing trends. Stay ahead with our data-driven strategies and AI-powered techniques.',
    keywords: 'digital marketing blog, SEO tips, GEO guide, CRO best practices, marketing insights'
  }
};

export const structuredDataTemplates = {
  organization: {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    '@id': 'https://jamaklab.com/#organization',
    name: 'Jamak',
    url: 'https://jamaklab.com',
    logo: 'https://jamaklab.com/images/logos/logo-jamak.png',
    slogan: 'Your fractional growth partner',
    description: 'AI implementation agency for businesses ready to put AI to work. AI agents, workflow automation, websites and Shopify stores. Building since 2011.',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Polanco',
      addressLocality: 'Mexico City',
      addressRegion: 'CDMX',
      postalCode: '11560',
      addressCountry: 'MX'
    },
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'hello@jamaklab.com',
      contactType: 'sales',
      availableLanguage: ['English', 'Spanish']
    }
  },
  service: (serviceName, description, price) => ({
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: serviceName,
    description: description,
    provider: {
      '@type': 'Organization',
      name: 'Jamak'
    },
    areaServed: {
      '@type': 'Country',
      name: 'Worldwide'
    },
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: serviceName + ' Packages',
      itemListElement: price ? [
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: serviceName
          },
          price: price,
          priceCurrency: 'USD'
        }
      ] : []
    }
  }),
  breadcrumb: (items) => ({
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url
    }))
  }),
  article: (title, description, author, datePublished, image, dateModified = null) => ({
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: title,
    description: description,
    author: {
      '@type': 'Person',
      name: author || 'Jamak'
    },
    datePublished: datePublished,
    dateModified: dateModified || datePublished,
    publisher: {
      '@type': 'Organization',
      name: 'Jamak',
      logo: {
        '@type': 'ImageObject',
        url: 'https://jamaklab.com/images/logos/logo-jamak.png'
      }
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': window.location.href
    },
    image: image || 'https://jamaklab.com/images/hero/jamak-rabbit.png'
  }),
  faq: (questions) => ({
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: questions.map(q => ({
      '@type': 'Question',
      name: q.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: q.answer
      }
    }))
  }),
  review: (rating, count) => ({
    '@context': 'https://schema.org',
    '@type': 'AggregateRating',
    ratingValue: rating,
    reviewCount: count,
    bestRating: '5',
    worstRating: '1'
  }),
  speakable: (text) => ({
    '@context': 'https://schema.org',
    '@type': 'SpeakableSpecification',
    'cssSelector': ['.speakable', 'h1', 'h2'],
    'xpath': ['/html/head/title', '/html/head/meta[@name="description"]/@content']
  }),
  dataset: (name, description, url) => ({
    '@context': 'https://schema.org',
    '@type': 'Dataset',
    name: name,
    description: description,
    url: url,
    creator: {
      '@type': 'Organization',
      name: 'Jamak'
    },
    distribution: {
      '@type': 'DataDownload',
      encodingFormat: 'CSV',
      contentUrl: url
    }
  }),
  videoObject: (name, description, thumbnailUrl, uploadDate, duration) => ({
    '@context': 'https://schema.org',
    '@type': 'VideoObject',
    name: name,
    description: description,
    thumbnailUrl: thumbnailUrl,
    uploadDate: uploadDate,
    duration: duration,
    publisher: {
      '@type': 'Organization',
      name: 'Jamak',
      logo: {
        '@type': 'ImageObject',
        url: 'https://jamaklab.com/images/og/og-square.png?v=r02'
      }
    }
  }),
  howTo: (name, steps, totalTime) => ({
    '@context': 'https://schema.org',
    '@type': 'HowTo',
    name: name,
    totalTime: totalTime,
    step: steps.map((step, index) => ({
      '@type': 'HowToStep',
      position: index + 1,
      name: step.name,
      text: step.text
    }))
  }),
  event: (name, startDate, endDate, location, description) => ({
    '@context': 'https://schema.org',
    '@type': 'Event',
    name: name,
    startDate: startDate,
    endDate: endDate,
    location: {
      '@type': 'Place',
      name: location.name,
      address: {
        '@type': 'PostalAddress',
        streetAddress: location.street,
        addressLocality: location.city,
        postalCode: location.postal,
        addressCountry: location.country
      }
    },
    description: description,
    organizer: {
      '@type': 'Organization',
      name: 'Jamak',
      url: 'https://jamaklab.com'
    },
    hasPart: [
      {
        '@type': 'WebPage',
        '@id': 'https://jamaklab.com/services/seo',
        'name': 'SEO Services',
        'url': 'https://jamaklab.com/services/seo'
      },
      {
        '@type': 'WebPage',
        '@id': 'https://jamaklab.com/services/geo',
        'name': 'GEO Services',
        'url': 'https://jamaklab.com/services/geo'
      },
      {
        '@type': 'WebPage',
        '@id': 'https://jamaklab.com/services/cro',
        'name': 'CRO Services',
        'url': 'https://jamaklab.com/services/cro'
      },
      {
        '@type': 'WebPage',
        '@id': 'https://jamaklab.com/services/shopify',
        'name': 'Shopify Services',
        'url': 'https://jamaklab.com/services/shopify'
      },
      {
        '@type': 'WebPage',
        '@id': 'https://jamaklab.com/services/saas',
        'name': 'SaaS & App Development',
        'url': 'https://jamaklab.com/services/saas'
      },
      {
        '@type': 'WebPage',
        '@id': 'https://jamaklab.com/services/ai-implementation',
        'name': 'AI Implementation',
        'url': 'https://jamaklab.com/services/ai-implementation'
      },
      {
        '@type': 'WebPage',
        '@id': 'https://jamaklab.com/services/ai-agents',
        'name': 'AI Agent Development',
        'url': 'https://jamaklab.com/services/ai-agents'
      }
    ]
  }),
  courseInstance: (courseName, description, provider, duration) => ({
    '@context': 'https://schema.org',
    '@type': 'CourseInstance',
    name: courseName,
    description: description,
    provider: {
      '@type': 'Organization',
      name: provider || 'Jamak'
    },
    duration: duration
  }),
  searchAction: {
    '@context': 'https://schema.org',
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: 'https://jamaklab.com/search?q={search_term_string}'
    },
    'query-input': 'required name=search_term_string'
  }
};